// LIST OF ALL PERMISSIONS
// {feature}_{action}_{resource}
export enum PermissionName {
  // Global
  Test = 'Test',

  // Dashboard
  Dashboard_Read_KpiTodayMissing = 'Dashboard_Read_KpiTodayMissing',
  Dashboard_Read_KpiNoiseLevel = 'Dashboard_Read_KpiNoiseLevel',

  // Leak Detection
  LeakDetection_Read_DeveloperColumns = 'LeakDetection_Read_DeveloperColumns',
  LeakDetection_Read_LoggersGrouped = 'LeakDetection_Read_LoggersGrouped',
  LeakDetection_Write_Comments = 'LeakDetection_Write_Comments',
}
